//Import icons assets here, exported into application.
import AttachmentIcon from './attachment-icon.svg';
import DocDownload from './doc-download.svg';
import Bday from './cake-birthday.svg';
import CRM from './card-account-details-outline.svg';
import DetailedEmployer from './detailed-employer.svg';
import DetailedPOrg from './detailed-parent-org.svg';
import DetailedInd from './detailed-industry.svg';
import DetailedLoc from './detailed-location.svg';
import DetailedSkill from './detailed-skill.svg';
import DetailedLoc2 from './detailed-loc2.svg';
import DetailedMain from './detailed-main.svg';
import DetailedPhone from './detailed-phone.svg';
import DetailedEmail from './detailed-email.svg';
import DetailedWallet from './detailed-wallet-icon.svg';
import DetailedClock from './detailed-clock-icon.svg';
import DetailedSchedule from './detailed-schedule-icon.svg';
import DetailedDate from './detailed-start-date-icon.svg';
import DetailedTags from './detailed-tags.svg';
import DetailedTraining from './detailed-training-class.svg';
import DetailedCert from './diploma.svg';
import DetailedTraining2 from './training.svg';
import DetailedJC from './job-coach.svg';
import DetailedDay from './daytime.svg';
import DetailedPlus from './plus.svg';
import DetailedPCheck from './police-check.svg';
import DetailedCCheck from './credit-check.svg';
import DetailedJob from './jobs-icon.svg';
import DetailedTime from './time-past.svg';
import EditIconSm from './edit-icon-sm.webp';
import EditIconMd from './edit-icon-md.webp';
import EditIconLg from './edit-icon-lrg.webp';
import GlobeIcon from './globe.svg';
import LockIcon from './lock.svg';
import Notes from './notes-comments.svg';
import NoNot from './unactivated-notification.svg';
import SwooshGif from './nike-animation.gif';
import WaveGif from '../gifs/wave.gif';
import YesNot from './activated-notification.svg';
import Confetti from '../gifs/confetti.gif';
import MagnifyingGlass from '../gifs/magnifying-glass.gif';
import Express from '../gifs/express.gif';
import JobApplication from './job-applications.svg';
import JobMenuItem from './jobs-menu-item.svg';
import ProfileIcon from './profile-icon.svg';
import ChatIcon from './new-messages-nav.png';
import Edit from './edit.svg';
import Dashboard from './dashboard icon.svg';
import Profile from './MJM-Employers.svg';
import Jobs from './MJM-Jobs.svg';
import Help from './MJM-Help.svg';
import MyJobMatches from './MJM-Job Matches.svg';
import MyActivity from './MJM-Activity.svg';
import ActivityAdded from './activity-add-icon.svg';
import ActivityEdited from './activity-edit-icon.webp';
import ActivityExpressInterest from './activity-job-icon.webp';
import ActivityRemoved from './activity-remove-icon.svg';
import ActivityLike from './activity-like.svg';
import ActivityUnlike from './activity-unlike.svg';
import ActivityLoggedIn from './activity-login.svg';
import ActivityStatusUpdate from './activity-update.svg';
import Accommodations from './detailed-accommodations.svg';
import JobType from './jobtype.svg';

const Icon = {
  AttachmentIcon,
  DocDownload,
  Bday,
  CRM,
  Confetti,
  DetailedClock,
  DetailedCert,
  DetailedCCheck,
  DetailedDate,
  DetailedDay,
  DetailedEmail,
  DetailedEmployer,
  DetailedInd,
  DetailedJC,
  DetailedJob,
  DetailedLoc,
  DetailedLoc2,
  DetailedMain,
  DetailedPhone,
  DetailedPlus,
  DetailedPOrg,
  DetailedPCheck,
  DetailedSchedule,
  DetailedSkill,
  DetailedTags,
  DetailedTime,
  DetailedTraining2,
  DetailedTraining,
  DetailedWallet,
  EditIconSm,
  EditIconMd,
  EditIconLg,
  Express,
  GlobeIcon,
  MagnifyingGlass,
  LockIcon,
  NoNot,
  Notes,
  SwooshGif,
  YesNot,
  JobApplication,
  JobMenuItem,
  ProfileIcon,
  Edit,
  ActivityAdded,
  ActivityEdited,
  ActivityExpressInterest,
  ActivityRemoved,
  Help,
  Jobs,
  Profile,
  Dashboard,
  MyJobMatches,
  MyActivity,
  WaveGif,
  ActivityLike,
  ActivityUnlike,
  ActivityLoggedIn,
  ActivityStatusUpdate,
  Accommodations,
  JobType,
  ChatIcon
};

export default Icon;
